// latest: zhangmyh 2017-10-24 6:55 PM
import { Model } from 'common'
import './baseInfos'
import './qualifyInfos'
import './suitOrgs'

Model.define('template.qualify', {
  proxy: {},
  meta: {
    id: '',
    code: '',
    versionNo: '',
    creatorName: '',
    createTime: {
      type: 'date',
    },
    isGlobal: '',
    name: {
      ag: {
        required: true,
        nullMsg: '请填写模版名称'
      }
    },
    approver: '',
    approverName: '',
    approveTime: { type: 'date' },
    createOrgId: '',
    createOrgName: '',
    classId: '',
    className: '',
    description: {
      ag: {
        required: true,
        nullMsg: '请填写模版描述'
      }
    },
    enableStatus: '',
    templetType: '',
    certificationSystemId: '',
    certificationSystemName: '',
    extMemo: '',
    showOrg: '',
    ts: ''
  },
  associations: {
    suitOrgs: { // 组织子表
      type: 'hasMany', // hasMany
      model: 'template.suitorg'
    },
    baseInfos: { // 指标子表
      type: 'hasMany', // hasMany
      model: 'template.baseinfo'
    },
    qualifyInfos: { // 资质子表
      type: 'hasMany', // hasMany
      model: 'template.qlfinfo'
    },
  }
})

export default Model.create('template.qualify')



// WEBPACK FOOTER //
// ./src/data/model/qualifyTpl/index.js